export const datePresetOptions = [
    { label: '전체', value: 'all' },
    { label: '오늘', value: 'today' },
    { label: '어제', value: 'yesterday' },
    { label: '이번 주', value: 'thisWeek' },
    { label: '지난 주', value: 'lastWeek' },
    { label: '이번 달', value: 'thisMonth' },
    { label: '지난 달', value: 'lastMonth' },
    { label: '직접 선택', value: 'custom' }
];